import {
	chains,
} from "..";

export declare type SupportedChainId = keyof typeof chains;
export const supportedChainIds = Object.keys(chains).map(k => Number(k));

export const isSupportedChainId = ( value: unknown, ): value is SupportedChainId =>
	typeof value === "number" && supportedChainIds.includes(value);
